import useErrorReportingStore from '../../errorReportingStore/useErrorReportingStore';
import { LoanDocumentType } from '../types/LoanDocumentType';

export const reportUploadError =
  (document: LoanDocumentType) =>
  (error: Error): LoanDocumentType => {
    const { captureException } = useErrorReportingStore.getState();

    captureException(error, {
      extra: {
        FileSize: document.file.size,
        FileType: document.file.type,
      },
      tags: { 'document.loan.type': document.type },
    });

    return document;
  };
